/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/typedef */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
// language.service.ts
import { Injectable } from '@angular/core';

interface PageInfo {
    locale: string;
    key: string;
}

@Injectable({
    providedIn: 'root'
})

export class LanguageService {
    private defaultLanguage: string = 'en'; // Default language
    private defaultLocale: string = 'en'; // Default language

    constructor() {}

    GetLanguage(): string {
        const languageCookie = this.GetCookie('language');

        return languageCookie || this.defaultLanguage;
    }

    private GetCookie(name: string): string | null {
        const cookieValue = document.cookie.match(`(^|;)\\s*${  name  }\\s*=\\s*([^;]+)`);

        return cookieValue ? cookieValue.pop() : null;
    }

    public GetLocale(urlLocale: string | null): string {
        if (urlLocale === 'no-no') {
            return 'no';
        }
        
        return urlLocale ? urlLocale : this.defaultLocale;
    }

    public PatternToUrl(url: string, urlLocale: string | null): string {
        url = url.replace(/\\/g, '');
        url = url.replace('{locale}', this.GetLocale(urlLocale));
        url = url.replace(/\(\.\*\)/g, '');
    
        return url;
    }

    public GetLink(key: string, lang: string | null, routemap: any): string {
        if(!routemap[key]){
            return `/${this.defaultLocale}/`;
        }
        
        lang = lang || this.defaultLanguage;

        const url = routemap[key][lang]?.url || routemap[key].default?.url;

        return url ? this.PatternToUrl(url, lang) : `/${this.defaultLocale}/`
    }

    public GetPageLink(page: PageInfo, lang: string | null, routemap: any): string {
        return this.GetLink(page.key, lang, routemap);
    }
}
